import { render } from "./TeamStreamLayout.vue?vue&type=template&id=40d4f070&scoped=true"
import script from "./TeamStreamLayout.vue?vue&type=script&lang=js"
export * from "./TeamStreamLayout.vue?vue&type=script&lang=js"

import "./TeamStreamLayout.vue?vue&type=style&index=0&id=40d4f070&lang=scss"
import "./TeamStreamLayout.vue?vue&type=style&index=1&id=40d4f070&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40d4f070"

export default script